import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  constructor(private location: Location) {
    // Prevent back navigation
    history.pushState(null, '', window.location.href);
    window.onpopstate = () => {
      history.pushState(null, '', window.location.href);
    };
  }

  ngOnInit(): void {
    // Disable browser back/forward navigation
    window.history.forward();
  }

  ngOnDestroy(): void {
    // Clean up the popstate event listener when component is destroyed
    window.onpopstate = null;
  }
}
